import Renderable from "Component/Renderable";
import { populate } from "populate";

const raw = {
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: "ca8d1c31-3c77-48cc-b4d6-2764b3881c0b",
      type: "Container",
      name: "root",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "",
      data: ""
    },
    {
      id: "d03a2e25-549f-4937-8fa6-2fde9187af0b",
      type: "Sprite",
      name: "avatar",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "no_avatar",
      parent: "ca8d1c31-3c77-48cc-b4d6-2764b3881c0b",
      data: ""
    },
    {
      id: "40849a7a-50d9-4883-b32a-80a2fd8ca132",
      type: "Sprite",
      name: "fieldBG",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "apple_field_unlock",
      parent: "ca8d1c31-3c77-48cc-b4d6-2764b3881c0b",
      data: ""
    },
    {
      id: "cd870630-47db-4811-97e3-c64effd83645",
      type: "Sprite",
      name: "shareBorder",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "hard_level_share_border",
      parent: "ca8d1c31-3c77-48cc-b4d6-2764b3881c0b",
      data: ""
    },
    {
      id: "1ff1564a-b4f4-4015-ab0d-380d54178c80",
      type: "Sprite",
      name: "shareButton",
      nameSpace: "",
      className: "",
      x: -3,
      y: 292,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: "None"
      },
      texture: "button_medium_blue",
      parent: "ca8d1c31-3c77-48cc-b4d6-2764b3881c0b",
      data: ""
    },
    {
      id: "c0bf4779-9e75-4605-bee1-42c334e5f70c",
      type: "Sprite",
      name: "continueButton",
      nameSpace: "",
      className: "",
      x: -3,
      y: 292,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: "None"
      },
      texture: "button_medium_green",
      parent: "ca8d1c31-3c77-48cc-b4d6-2764b3881c0b",
      data: ""
    },
    {
      id: "c787d206-ecff-4fc3-bd50-eb95cbd50c9a",
      type: "Sprite",
      name: "closeButton",
      nameSpace: "",
      className: "",
      x: 522,
      y: -323,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: "None"
      },
      texture: "x_button",
      parent: "ca8d1c31-3c77-48cc-b4d6-2764b3881c0b",
      data: ""
    },
    {
      id: "c1ae1257-5e6d-4337-94c2-9f5b49fbed5c",
      type: "Text",
      name: "titleText",
      nameSpace: "",
      className: "",
      x: 0,
      y: -318,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "ShareHard",
      localize: false,
      maxWidth: 700,
      maxHeight: 70,
      maxFontSize: 51,
      icons: [],
      style: {
        fontSize: 51,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ffffff",
        stroke: "#00000059",
        strokeThickness: 6,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "cd870630-47db-4811-97e3-c64effd83645",
      data: ""
    },
    {
      id: "57c55f16-2879-45a5-807a-dafd8c23699a",
      type: "Text",
      name: "shareText",
      nameSpace: "",
      className: "",
      x: 0,
      y: -5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "Share",
      localize: false,
      maxWidth: 131,
      maxHeight: 70,
      maxFontSize: 51,
      icons: [],
      style: {
        fontSize: 51,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ffffff",
        stroke: "#00000059",
        strokeThickness: 6,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "1ff1564a-b4f4-4015-ab0d-380d54178c80",
      data: ""
    },
    {
      id: "2fd61c2d-a5e8-4326-adb6-569121043c07",
      type: "Text",
      name: "continueText",
      nameSpace: "",
      className: "",
      x: 0,
      y: -5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "Continue",
      localize: false,
      maxWidth: 131,
      maxHeight: 70,
      maxFontSize: 51,
      icons: [],
      style: {
        fontSize: 51,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ffffff",
        stroke: "#00000059",
        strokeThickness: 6,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "c0bf4779-9e75-4605-bee1-42c334e5f70c",
      data: ""
    }
  ]
} as const;

export class HardSharePopupLayout {
  static raw = raw;
  root: GameObject<PIXI.Container>;
  avatar: GameObject<PIXI.Sprite>;
  fieldBG: GameObject<PIXI.Sprite>;
  shareBorder: GameObject<PIXI.Sprite>;
  titleText: GameObject<PIXI.Text>;
  shareButton: GameObject<PIXI.Sprite>;
  shareText: GameObject<PIXI.Text>;
  continueButton: GameObject<PIXI.Sprite>;
  continueText: GameObject<PIXI.Text>;
  closeButton: GameObject<PIXI.Sprite>;

  constructor() {
    populate(this, raw);
    this.shareButton.getComponent(Renderable).container.visible = false;
  }
}
